import { postVerificationCodeRoute } from "@api-routes/otpVerification";
import { useFetch } from "@common/hook/useFetch";
import { IPostVerifyCodeResult } from "../interface/IPostVerifyCodeResult";

export const useValidateCode = (setErrorMessage: (errorMessage: string) => void) => {
    const [, { post }] = useFetch();

    const verifyCode = (smsCode: string, otpUuid?: string) =>
        post<IPostVerifyCodeResult>(postVerificationCodeRoute(otpUuid), {
            body: { otp: `${smsCode}` },
        }).then((result) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });

    return {
        verifyCode,
    };
};
